// Maps a Firebase auth error to a clean ERRORS.* i18n key.
// Raw Firebase messages can't be translated: their text contains ':' and '.',
// which i18next treats as namespace/key separators.
const AUTH_ERROR_KEYS = {
  'auth/email-already-in-use': 'AUTH_EMAIL_IN_USE',
  'auth/account-exists-with-different-credential': 'AUTH_EMAIL_IN_USE',
  'auth/invalid-email': 'AUTH_INVALID_EMAIL',
  'auth/missing-email': 'AUTH_MISSING_EMAIL',
  'auth/missing-password': 'AUTH_MISSING_PASSWORD',
  'auth/weak-password': 'AUTH_WEAK_PASSWORD',
  'auth/invalid-credential': 'AUTH_INVALID_CREDENTIAL',
  'auth/wrong-password': 'AUTH_INVALID_CREDENTIAL',
  'auth/user-not-found': 'AUTH_INVALID_CREDENTIAL',
  'auth/user-disabled': 'AUTH_USER_DISABLED',
  'auth/too-many-requests': 'AUTH_TOO_MANY_REQUESTS',
  'auth/network-request-failed': 'AUTH_NETWORK_ERROR'
};

const getAuthErrorKey = (error) => AUTH_ERROR_KEYS[error?.code] || 'AUTH_ERROR';

export default getAuthErrorKey;
